import { ChevronRight, Menu } from "lucide-react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { getPanelDefaultRoute } from "@src/router/routes";
import { PanelUserDropdown } from "@components/navbar-common";
import themeConfig from "@configs/theme-config";
import BrandSwitcher from "@layouts/components/topbar/brand-switcher";
import PaymentModelToggle from "@layouts/components/topbar/payment-model-toggle";
import PublisherSwitcher from "@layouts/components/topbar/publisher-switcher";
import useActiveNav from "@layouts/hooks/use-active-nav";

const Navbar = (props) => {
  // ** Props
  const { setMenuVisibility, menuHidden, menuData } = props;
  const {
    app: { logo }
  } = themeConfig;
  const { label, homeLink, title } = useActiveNav(menuData);

  return (
    <>
      <div className="flex min-w-0 flex-1 items-center gap-3">
        {menuHidden ? (
          <Link to={getPanelDefaultRoute()} className="flex items-center gap-2">
            <img
              src={logo}
              alt="NookPay"
              className="h-8 w-8 rounded-lg object-cover"
            />
            <span className="text-base font-semibold tracking-tight text-gray-900">
              NookPay
            </span>
          </Link>
        ) : (
          <>
            <button
              type="button"
              aria-label="Open navigation"
              className="flex shrink-0 cursor-pointer items-center text-gray-700"
              onClick={() => setMenuVisibility(true)}
            >
              <Menu size={24} />
            </button>
            <nav className="flex min-w-0 items-center gap-1.5 text-sm">
              {label && (
                <>
                  <Link
                    to={homeLink}
                    className="hidden shrink-0 text-muted hover:text-gray-700 sm:inline"
                  >
                    {label}
                  </Link>
                  <ChevronRight className="hidden h-3.5 w-3.5 shrink-0 text-gray-300 sm:block" />
                </>
              )}
              <span className="truncate font-medium text-gray-900">
                {title}
              </span>
            </nav>
          </>
        )}
      </div>

      <div className="ml-auto flex shrink-0 items-center gap-2 pl-2">
        <PaymentModelToggle />
        <BrandSwitcher />
        <PublisherSwitcher />
        <PanelUserDropdown />
      </div>
    </>
  );
};

Navbar.propTypes = {
  menuData: PropTypes.shape({
    panel: PropTypes.array,
    label: PropTypes.string
  })
};

export default Navbar;
